/**
 * ecommate: Sync SKU / EAN on variant change
 */
if (!customElements.get('em-artikel-infos')) {
  class EmArtikelInfos extends HTMLElement {
    connectedCallback() {
      const jsonEl = this.querySelector('[data-em-artikel-variants]');
      try {
        this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (e) {
        this.variants = [];
      }
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onFormChange = this.onFormChange.bind(this);
      document.addEventListener('variant:change', this.onVariantChange);
      document.addEventListener('change', this.onFormChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      document.removeEventListener('change', this.onFormChange);
    }

    update(variantId) {
      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const root = this;
      const skuNodes = root.querySelectorAll
        ? root.querySelectorAll('[data-artikelnummer]')
        : [];
      const eanNodes = root.querySelectorAll
        ? root.querySelectorAll('[data-ean]')
        : [];

      skuNodes.forEach((el) => {
        el.textContent = variant.sku || '';
      });
      eanNodes.forEach((el) => {
        el.textContent = variant.barcode || '';
      });

      // Specs accordion may use display:contents; also sync any page-level nodes
      // that belong to the same product context when this host has no matches.
      if (!skuNodes.length) {
        document.querySelectorAll('[data-artikelnummer]').forEach((el) => {
          el.textContent = variant.sku || '';
        });
      }
      if (!eanNodes.length) {
        document.querySelectorAll('[data-ean]').forEach((el) => {
          el.textContent = variant.barcode || '';
        });
      }
    }

    onVariantChange(event) {
      if (event.detail && event.detail.variant) {
        this.update(event.detail.variant.id);
      }
    }

    onFormChange(event) {
      const form = event.target && event.target.closest && event.target.closest('form');
      if (!form) return;
      const idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      this.update(idInput.value);
    }
  }

  customElements.define('em-artikel-infos', EmArtikelInfos);
}
